import React, { useState } from 'react';
import { Button, Card, Checkbox, FormField, Heading, majorScale, Pane, Select, TagInput } from 'evergreen-ui';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { LoadUserFromGoogleDialog } from '../../../../../components/dialogs';
import { SelectGoogleGroupInput } from '../../../../../components/inputs'

const GoogleAddMemberToGroupForm = ({ submit }) => {
  const [allowEdit, setAllowEdit] = useState(false);
  const [isOwnerSelected, setIsOwnerSelected] = useState(false);

  const formik = useFormik({
    initialValues: {
      member_emails: [],
      group_email: '',
      owner_email: ''
    },
    onSubmit: (values) => submit(values),
    validationSchema: Yup.object().shape({
      member_emails: Yup.array()
        .of(Yup.string().email('Invalid').required('Required'))
        .min(1, 'At least one member email'),
      group_email: Yup.string().required('Email of the group is required'),
      owner_email: Yup.string().email('Invalid').notRequired(),
    }),
    validateOnChange: false,
  });

  const { values, errors, handleChange } = formik;

  const loadGoogleUser = (user) => {
    if (user) {
      formik.setFieldValue(
        'member_emails',
        Array.from(new Set([...formik.values.member_emails, user.email]))
      );
    }
  };

  const selectGoogleGroup = (googleGroups) => {
    if (googleGroups) {
      formik.setFieldValue('group_email', googleGroups);
    }
  };

  return (
    <Pane>
      <form onSubmit={formik.handleSubmit}>
        <Card border="default" marginBottom={majorScale(2)} paddingX={majorScale(2)} backgroundColor="white">
          <Pane
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            paddingY={majorScale(2)}
            borderBottom="1px solid #edeff5"
          >
            <Heading size={600}>Add a new member to a Google group</Heading>
            <LoadUserFromGoogleDialog onSelect={loadGoogleUser} />
          </Pane>
          <Pane marginTop={majorScale(2)}>
            <FormField
              label="Member Emails"
              validationMessage={formik.errors.member_emails}
              hint="You can add as many members as you need with the 'Load user from Google' button"
            >
              <TagInput
                values={formik.values.member_emails}
                onChange={tags => formik.setFieldValue('member_emails', tags)}
                width="30%"
                addOnBlur
              />
            </FormField>
          </Pane>

          <Pane paddingBottom={majorScale(2)}>
            <FormField
              label="Group Email"
              marginTop={majorScale(2)}
              maxWidth="50%"
              validationMessage={formik.errors.group_email}
            >
              <SelectGoogleGroupInput
                value={formik.values.group_email}
                onSelect={selectGoogleGroup}
              />
            </FormField>
          </Pane>

          {values.member_emails.length > 0 && (
            <Pane marginTop={majorScale(2)}>
              <Checkbox
                label="Do you want to make one of the members an owner?"
                checked={isOwnerSelected}
                onChange={() => setIsOwnerSelected(!isOwnerSelected)}
              />

              {isOwnerSelected && (
                <FormField label="Select Owner" paddingBottom={majorScale(2)}>
                  <Select
                    value={formik.values.owner_email}
                    onChange={(e) => formik.setFieldValue('owner_email', e.target.value)}
                  >
                    <option value="">Select a member</option>
                    {values.member_emails.map((email) => (
                      <option key={email} value={email}>{email}</option>
                    ))}
                  </Select>
                </FormField>
              )}
            </Pane>
          )}
        </Card>

        <Card
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          backgroundColor="white"
          padding={majorScale(2)}
          border
        >
          <Button type="button" disabled={formik.isSubmitting}>
            Cancel
          </Button>

          <Button
            marginLeft={majorScale(2)}
            appearance="primary"
            type="submit"
            isLoading={formik.isSubmitting}
            disabled={!formik.isValid}
          >
            Submit
          </Button>
        </Card>
      </form>
    </Pane>
  );
};

export default GoogleAddMemberToGroupForm;
